<template>
  <VCard elevation="0" class="grey lighten-5 pa-0 pa-md-8 mt-0 mt-md-4 presets">
    <h2 class="d-none d-md-block">
      {{ $t('create') }}
    </h2>
    <VacancyNewTemplateList
      :presets="presetsCommon"
      :vacancy="vacancy"
      @select="setPreset"
      @aiInterview="setAiInterviewer"
      @faqAiInterview="openFaqAiInterview"
      class="mb-3"
    />

    <div class="d-none d-md-block">
      <VRow>
        <VCol cols="12" lg="9">
          <h2>{{ $t('choose') }}</h2>
        </VCol>
        <VCol cols="12" lg="3">
          <VacancyPresetsSearch @search="setSearch" />
        </VCol>
      </VRow>
      <VRow v-if="presetsFiltered.length > 0">
        <VCol cols="12" lg="4">
          <VacancyPresetsCategories
            :categories="categories"
            @selectCategory="setActiveCategory"
          />
        </VCol>
        <VCol cols="12" lg="8">
          <template v-if="presetsFiltered.length > 0">
            <VacancyPresetsList @select="setPreset" :presets="presetsFiltered" :selected="selected" />
            <VacancyPresetsListNotFound />
          </template>
          <template v-else>
            {{ $t('notFound') }}
            <VacancyPresetsListNotFound />
          </template>
        </VCol>
      </VRow>
      <VRow v-else>
        <VCol>
          {{ $t('notFound') }}
          <VacancyPresetsListNotFound />
        </VCol>
      </VRow>
      <VacancyPresetInterviewers
        @selected="setInterviewer"
        @setAiInterviewer="setAiInterviewer"
        v-model="showDialog"
        v-if="selected.preset"
        :preset="selected.preset"
        :avatars="avatars"
        :vacancy-id="vacancy.id"
        :ai-interview-preset-id="aiInterviewPresetId"
      />
    </div>

    <VDialog v-if="$vuetify.breakpoint.smAndDown" v-model="show" fullscreen>
      <template v-slot:activator="{ on }">
        <a v-on="on" class="preset-copy-link mb-3">
          <div class="preset-copy-link__title d-md-none">
            {{ $t('templateLibrary') }}
          </div>
          <div>
            {{ $t('chooseTemplate') }}
          </div>
          <div class="wizard-counts mt-1 d-md-none">
            <VIcon
              class="mr-1"
              color="grey lighten-1"
            >
              mdi-format-list-numbered
            </VIcon>
            {{ presets.length }} {{ $tc('templates', presets.length) }}
          </div>
          <div class="template-arrow-icon">
            <VIcon
              color="grey lighten-2"
            >
              mdi-chevron-right
            </VIcon>
          </div>
        </a>
      </template>
      <VCard class="grey lighten-5">
        <div class="white pa-4">
          <VBtn
            fab
            icon
            small
            absolute
            top
            right
            @click="show = false"
            class="mt-6 mr-n4"
          >
            <VIcon>
              mdi-close
            </VIcon>
          </VBtn>
          <div class="step-title px-0 mb-n4">
            {{ $t('choose') }}
          </div>
          <div class="step-subtitle px-0">
            {{ $t('libraryHint') }}
          </div>
        </div>
        <VCardText class="px-4 mt-4">
          <VacancyPresetsSearch class="mb-4" :value="search" @search="setSearch" />
          <VTextField
            v-if="activeCategory || search"
            :value="activeCategory && activeCategory[0] ? activeCategory[0].name : $t('all')"
            readonly
            outlined
            dense
            hide-details
            append-icon="mdi-format-list-bulleted"
            class="presets-category mb-3 font-weight-300"
            @click="resetSearch"
          />
          <template v-if="presetsFiltered.length > 0">
            <VacancyPresetsCategories
              v-if="!activeCategory && !search"
              class="presets-mobile py-4"
              :categories="categories"
              @selectCategory="setActiveCategory"
            />
            <template v-else>
              <VacancyPresetsList @select="setPreset" :presets="presetsFiltered" :selected="selected" />
              <VacancyPresetInterviewers
                @selected="setInterviewer"
                v-model="showDialog"
                v-if="selected.preset"
                :preset="selected.preset"
                :avatars="avatars"
                :vacancy-id="vacancy.id"
                :ai-interview-preset-id="aiInterviewPresetId"
              />
            </template>
          </template>
          <div class="text-center mt-6" v-else>
            {{ $t('notFound') }}
          </div>
        </VCardText>
      </VCard>
    </VDialog>
    <VDialog v-model="aiInterviewDialog" max-width="560" class="ai-dialog">
      <div class="modal relative">
        <VCard class="modal__wrap">
          <VCardTitle class="modal__wrap_title">
            {{ $t('onTariff') }}
          </VCardTitle>
          <VBtn
            fab
            icon
            small
            absolute
            top
            right
            @click="aiInterviewDialog = false"
            class="mt-6 mr-n4"
          >
            <VIcon>
              mdi-close
            </VIcon>
          </VBtn>
          <VList class="modal__wrap_list">
            <VListItem v-for="(item, index) in modalListItem" :key="index" class="pa-0 list__item">
              <div class="list__item_wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    width="24"
                    height="24"
                    rx="12"
                    fill="#1FC57F"
                  />
                  <g clip-path="url(#clip0_4133_232)">
                    <path d="M10.32 15.7699C10.1863 15.77 10.0538 15.7436 9.93028 15.6924C9.80674 15.6412 9.6945 15.5662 9.60001 15.4715L7.37561 13.2483L8.22441 12.3999L10.32 14.4955L15.7756 9.03992L16.6244 9.88832L11.04 15.4715C10.9455 15.5662 10.8333 15.6412 10.7097 15.6924C10.5862 15.7436 10.4538 15.77 10.32 15.7699Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4133_232">
                      <rect
                        width="9.6"
                        height="9.6"
                        fill="white"
                        transform="translate(7.19995 7.19995)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <span>
                  {{ $t(`${item.text}`) }}
                </span>
              </div>
            </VListItem>
          </VList>
          <VCardActions class="modal__wrap_actions">
            <VBtn
              class="try-btn"
              @click="setPreset('aiInterview')"
            >
              {{ $t('try') }}
            </VBtn>
            <div class="modal__wrap_actions-text">
              {{ $t('tryIt') }}
            </div>
          </VCardActions>
        </VCard>
      </div>
    </VDialog>
  </VCard>
</template>

<script>
import { safeGet } from '@/functions';
import VacancyPresetsList from '@/components/Vacancy/VacancyPresetsList';
import VacancyPresetsCategories from '@/components/Vacancy/VacancyPresetsCategories';
import VacancyPresetsSearch from '@/components/Vacancy/VacancyPresetsSearch';
import InterviewPresetCategory from '@/orm/models/Interview/InterviewPresetCategory';
import VacancyPresetInterviewers from '@/components/Vacancy/VacancyPresetInterviewers';
import VacancyNewTemplateList from '@/components/Vacancy/VacancyNewTemplateList';
import { interviewPresetTypes } from '@/enums';
import InterviewPreset from '@/orm/models/Interview/InterviewPreset';
import escapeRegExp from 'lodash.escaperegexp';
import VacancyPresetsListNotFound from '@/components/Vacancy/VacancyPresetsListNotFound';

export default {
  name: 'VacancyPresets',
  components: {
    VacancyPresetsListNotFound,
    VacancyNewTemplateList,
    VacancyPresetInterviewers,
    VacancyPresetsList,
    VacancyPresetsCategories,
    VacancyPresetsSearch,
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    avatars: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      aiInterviewDialog: false,
      activeCategory: [],
      search: '',
      searchBy: [
        'description',
        'summary',
        'title',
      ],
      selected: {
        preset: {},
        interviewer: {},
      },
      selectedPreset: null,
      showDialog: false,
      isEmptyPreset: false,
      modalListItem: [
        { text: ('generationQ') },
        { text: ('voicingQ') },
        { text: ('analyzQ') },
      ],
    };
  },
  computed: {
    allPresets() {
      return InterviewPreset.query().withAllRecursive().all();
    },
    presets() {
      return this.activeCategory[0]
        ? safeGet(this.category, [0, 'presetsModels'], [])
        : this.allPresets.filter((p) => p.type !== interviewPresetTypes.COMMON);
    },
    category() {
      return this.activeCategory || this.defaultCategory;
    },
    categories() {
      const data = InterviewPresetCategory.query().where('depth', 0).withAllRecursive().get();

      if (this.search !== '') {
        return data.filter((category) => this.filterPresets(safeGet(category, ['presetsModels'], [])).length > 0);
      }

      return data;
    },
    presetsFiltered() {
      if (this.search === '') {
        return this.presets;
      }
      return this.filterPresets(this.presets);
    },
    presetsCommon() {
      return this.allPresets.filter((preset) => preset.type === interviewPresetTypes.COMMON);
    },
    defaultCategory() {
      return InterviewPresetCategory.query().withAllRecursive().find(0);
    },
    isAiInterviewCompiled() {
      return this.vacancy.isAiInterviewCompiled;
    },
    aiInterviewPresetId() {
      return this.vacancy.aiInterviewPresetId;
    },
  },
  created() {
    this.insertAllCategory();
    if (this.vacancy?.hasAiQuestions && this.vacancy?.isAiInterviewCompiling) {
      this.setAiInterviewer(0);
    }
  },
  methods: {
    async insertAllCategory() {
      await InterviewPresetCategory.insert({
        data: [{
          id: 0,
          name: this.$t('all'),
          presets: InterviewPreset.query().all().map(((preset) => preset.id)).filter((p) => p.type !== interviewPresetTypes.COMMON),
        }],
      });
    },
    setActiveCategory(category) {
      this.activeCategory = category;
    },
    setSearch(val) {
      this.search = val.trim();
    },
    filterPresets(presets) {
      const regExp = new RegExp(escapeRegExp(this.search), 'gmiu');
      return presets.filter((preset) => this.searchBy.some(
        (field) => preset[field] && preset[field].match(regExp),
      ));
    },
    setPreset(preset) {
      this.selected.preset = preset;
      this.isEmptyPreset = preset === 'aiInterview' ? false : preset.interviewers.length === 0;
      this.$emit('input', preset === 'aiInterview' ? this.selected.preset : this.selected);
      this.showDialog = true;
    },
    setAiInterviewer() {
      this.$emit('setAiInterviewer');
    },
    openFaqAiInterview() {
      this.aiInterviewDialog = true;
    },
    setInterviewer(interviewer) {
      this.selected.interviewer = interviewer;
      this.$emit('input', this.selected);
    },
    resetSearch() {
      this.activeCategory = null;
      this.search = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-text-field--outlined fieldset {
    border: thin solid rgba(0, 0, 0, 0.12);
  }

  .presets-mobile {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    font-weight: 300;
    font-size: 16px;
    white-space: normal;
  }

  .presets-category {
    text-overflow: ellipsis;
  }

  .wizard-counts {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    font-weight: 300;
    font-size: 12px;
    line-height: 24px;
    color: #AAAAAA;

    i {
      font-size: 16px;
    }

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      padding: 0;
      margin-bottom: 10px;
      font-size: 16px;

      i {
        font-size: 20px;
      }
    }
  }

  .modal {
    &__wrap {
      &_title {
        padding: 25px;
        color: #212121;
        font-size: 20px;
        max-width: 470px;
        line-height: 120%;
      }
      &_list {
        padding: 0 25px;
      }
      &_actions {
        padding: 25px;
        @media screen and (max-width: 480px) {
          flex-direction: column-reverse;
        }
      }
      &_actions-text {
        color: #212121;
        font-size: 16px;
        line-height: 140%;
        @media screen and (max-width: 480px) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .try-btn {
    padding: 16px 23px !important;
    border-radius: 4px;
    background: #1FC57F !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.24);
    margin-right: 20px;

    color: #FFF;
    font-size: 16px;
    line-height: 20px;
    height: 52px !important;
  }
  .list {
    &__item {
      display: inline-block;
      border-radius: 5px;
      background: #F1F6FA;
      margin-bottom: 10px;
      width: 100%;
      &_wrap {
        display: flex;
        padding: 20px;
      }
      svg {
        margin-right: 10px;
        position: absolute;
      }
      span {
        margin-left: 35px;
        color: #212121;
        font-size: 18px;
        line-height: 120%;
        max-width: 405px;
      }
    }
  }

  ::v-deep {
    .v-dialog {
      border-radius: 20px !important;
    }
  }

</style>

<i18n locale="en" lang="yaml">
  create: Create custom interview template
  choose: Or choose template by profession
  notFound: Templates not found
  templateLibrary: Templates library
  chooseTemplate: Select a template from the library
  libraryHint: You will be able to edit questions at the next step
  templates: 'templates | template | templates'
  all: All
  onTariff: 'On the Standard and higher tariffs, you can use the advanced functionality:'
  try: To try
  tryIt: Try this feature, it will save you dozens of hours of work time.
  generationQ: Generating questions using AI
  voicingQ: Voicing any questions, not just selecting questions from a list
  analyzQ: "Analyzing all recorded interviews with the help of AI, highlighting the candidate's strengths and rating."
</i18n>

<i18n locale="ru" lang="yaml">
  create: Создайте свой шаблон интервью
  choose: Или выберите шаблон по специальности
  notFound: Шаблонов не найдено
  templateLibrary: Библиотека шаблонов
  chooseTemplate: Выбрать готовый шаблон в каталоге
  libraryHint: Отредактировать список вопросов вы сможете на следующем шаге
  templates: 'нет шаблонов | шаблон | шаблона | шаблонов'
  all: Все
  onTariff: 'На тарифах «Стандартный» и выше вы можете воспользоваться расширенным функционалом:'
  try: Попробовать
  tryIt: Попробуйте эту функцию, она сэкономит вам десятки часов рабочего времени.
  generationQ: Генерация вопросов с помощью ИИ
  voicingQ: Озвучивание любых вопросов, а не только выбор вопросов из списка
  analyzQ: 'Анализ всех записанных собеседований с помощью ИИ, выделение сильных сторон кандидата и выставление оценки.'
</i18n>
